import { ObjectId } from '@/interfaces/ObjectId'
import { defectStatisRequest } from '@/network/requests/defectStatis'
import { groupBy } from 'lodash'
import { workshopRequest } from '@/network/requests/workshop'
import jtInfo, { jtInfoRequest } from '@/network/requests/jtInfo'
import { getTechRequest } from '@/network/requests/tech'
import { defect_statis } from '@/interfaces/defect_statis'
import { realBatchInfoRequest } from '@/network/requests/realBatchInfo'
import { defectTypeRequest } from '@/network/requests/defectType'
import { getDefectRequest } from '@/network/requests/defect'
import { colorInfoRequest } from '@/network/requests/colorInfo'
import { getColorRequest } from '@/network/requests/color'
import { $in } from '@/network/util/QueryBuilder'
import { techInfoRequest } from '@/network/requests/techInfo'
import { getMeterYieldByDefectStatisList, getMeterYieldByJobOrderId } from './yieldService'
import { jtTechRequest } from '@/network/requests/jtTech'
import { jt_info } from '@/interfaces/jt_info'
import { techGroupDetailRequest } from '@/network/requests/techGroup'
import { tech_group_detail } from '@/interfaces/tech_group_detail'
import { tech_info } from '@/interfaces/tech_info'
import { sliceArray } from '@/util/sliceArray'

type TimeSection = {
	startTime: number
	endTime: number
}

/**
 * 根据外键数组，查询外键在指定时间段内的产量
 * 返回一个数组，每一项为一个时间段内的产量对象，该对象key为外键值，value为产量值
 */
async function getOutputMapOfForeignKeyWithTimeSection(foreignKey, foreignIdList: string[], timeSectionList: TimeSection[]) {
	return Promise.all(
		timeSectionList.map(async ({ startTime, endTime }) => {
			const defectStatisList = await defectStatisRequest.queryAll(
				{
					[foreignKey]: { $in: foreignIdList },
					begin_time: { $gt: { $date: startTime }, $lt: { $date: endTime } },
				},
				{ [foreignKey]: 1, total_len: 1 },
				undefined,
				1000
			)
			return defectStatisList.reduce(
				(acc, curr) => {
					const { total_len } = curr
					const foreignId = curr[foreignKey]
					if (foreignId) {
						acc[foreignId] += total_len
					}
					return acc
				},
				foreignIdList.reduce((acc, foreignId) => {
					acc[foreignId] = 0
					return acc
				}, {} as any)
			)
		})
	)
}
/**
 * 返回值形如：
 * [
 *      // 时间段 1
 *     {
 *         foreignKey001: {
 *              sumKey001: 130,
 *              sumKey002: 140
 *         },
 *         foreignKey002: {
 *              sumKey001: 350,
 *              sumKey002: 270
 *          }
 *     },
 *      // 时间段 2
 *     {
 *         foreignKey001: {
 *              sumKey001: 90,
 *              sumKey002: 40
 *         },
 *         foreignKey002: {
 *              sumKey001: 50,
 *              sumKey002: 20
 *          }
 *      }
 * ]
 * @param foreignKey defect_statis中的键
 * @param foreignIdList
 * @param sumKeys 用于计算加总的键，必须为标量
 * @param timeSectionList
 */
async function getSumValueMapOfForeignKeyWithTimeSection(foreignKey: string, foreignValueList: any[], sumKeys: string[], timeSectionList: TimeSection[]) {
	// 接口返回结果中要包含的 key
	const keys = sumKeys.reduce(
		(acc, key) => {
			acc[key] = 1
			return acc
		},
		{ [foreignKey]: 1 } as any
	)
	return Promise.all(
		timeSectionList.map(async ({ startTime, endTime }) => {
			console.log(`query defectStatis data list, filter by key: ${foreignKey} in ${JSON.stringify(foreignValueList)}, start_time: ${startTime}, end_time: ${endTime}`)
			let defectStatisList: defect_statis[]
			if (foreignValueList.length === 0) {
				defectStatisList = []
			} else {
				defectStatisList = await defectStatisRequest.queryAll(
					{
						[foreignKey]: { $in: foreignValueList },
						begin_time: { $gt: { $date: startTime }, $lt: { $date: endTime } },
					},
					{ ...keys, status: 1 },
					undefined,
					1000
				)
			}
			// 对于已经完成的批次，要查询 real_batch_info，对于未完成的批次，查询 defect_statis
			// 过滤正在进行中的批次
			const defectStatisInProcess = defectStatisList.filter(({ status }) => status !== 2)
			// 过滤已完成的批次
			const defectStatisFinished = defectStatisList.filter(({ status }) => status === 2)
			console.log(`foreignKey: ${foreignKey}, defectStatisList:`, defectStatisList)
			console.log(`foreignKey: ${foreignKey}, defectStatisInProcess:`, defectStatisInProcess)
			console.log(`foreignKey: ${foreignKey}, defectStatisFinished:`, defectStatisFinished)
			const finishedIds = defectStatisFinished.map(defectStatis => defectStatis._id!.$oid)
			const allSlice = sliceArray(finishedIds, 200)

			const realBatchInfoList = (
				await Promise.all(
					allSlice.map(idListSlice => {
						return realBatchInfoRequest.queryAll(
							{
								roll_id: { $in: idListSlice },
							},
							keys
						)
					})
				)
			).flat()

			console.log(`foreignKey: ${foreignKey}, realBatchInfoList:`, realBatchInfoList)
			// realBatchInfo 和 defectStatis 都存储了一些统计数据，这里直接将二者列表进行混合，可以看作一张总表。对于没有的属性，直接计为 0，对于二者共有的属性，可以直接加总
			return [...defectStatisInProcess, ...realBatchInfoList].reduce(
				(acc: any, curr: any) => {
					const foreignValue = curr[foreignKey] // 如 foreignKey 为jt_id，则forignValue 为某个机台id
					if (foreignValue) {
						const sumMap = acc[foreignValue] // 当前外键的加总计算对象
						for (const key of sumKeys) {
							// console.log('key & value of defectStatis data:', key, '==>', curr[key]);
							if (curr === undefined) {
								debugger
							}
							try {
								sumMap[key] += curr[key] || 0
							} catch (e) {
								debugger
							}
						}
					}
					return acc
				},
				foreignValueList.reduce((acc, foreignValue) => {
					acc[foreignValue] = sumKeys.reduce((acc, key) => {
						acc[key] = 0
						return acc
					}, {} as any)
					return acc
				}, {} as any)
			)
		})
	)
}

// 将 getOutputMapOfForeignKeyWithTimeSection 返回的结果组织成一个二维数组。每个子数组为某个具体外键的产量数据，根据时间段区分为多个。
async function getOutputOfForeignKey(foreignKey, foreignIdList: any[], timeSectionList: TimeSection[]): Promise<number[][]> {
	const result = await getOutputMapOfForeignKeyWithTimeSection(foreignKey, foreignIdList, timeSectionList)
	return foreignIdList.map(foreignId => result.map(outputOfTimeSection => outputOfTimeSection[foreignId]))
}

/**
 * 获取指定机台在指定时间段内的产量数据
 * @param jtIdList 机台id数组
 * @param timeSectionList 时间区间数组
 * @returns 返回一个二维数组，每一行表示每个机台的数据，顺序与传入的机台顺序一致
 * 参数示例：
 *      jtIdList = [ "5ee721ff23f1119f6663ebb3", "5f1caeb531a3d49a4929d7d0" ]
 *      timeSectionList = [{startTime: 1578009600000, endTime: 1578096000000}, {startTime: 1578096000000, endTime: 1578182400000}, {startTime: 1578268800000, endTime: 1578355200000}]
 * 表示查询两个机台在三个时间段内的产量数据，则应当返回一个两行三列的二维数组，其中行为机台，列为时间段
 *
 * 返回结果示例：
 * [
 *      [256, 341, 456],
 *      [123, 332, 887]
 * ]
 * 256 为 "5ee721ff23f1119f6663ebb3" 机台 在 { startTime: 1578009600000, endTime: 1578096000000 } 时间段内的产量
 * 332 为 "5f1caeb531a3d49a4929d7d0" 机台 在 {startTime: 1578096000000, endTime: 1578182400000} 时间段内的产量
 */
export async function getOutputOfDevice(jtIdList: string[], timeSectionList: TimeSection[]): Promise<number[][]> {
	return getOutputOfForeignKey('jt_id', jtIdList, timeSectionList)
}

/**
 * 获取指定工单在指定时间段内的产量数据。返回值参考 getOutputOfDevice 方法
 */
export async function getOutputOfWorkOrder(workOrderIdList: string[], timeSectionList: TimeSection[]): Promise<number[][]> {
	return getOutputOfForeignKey('work_order_id', workOrderIdList, timeSectionList)
}

/**
 * 获取指定派工单在指定时间段内的产量数据。返回值参考 getOutputOfDevice 方法
 */
export async function getOutputOfJobOrder(jobOrderIdList: string[], timeSectionList: TimeSection[]): Promise<number[][]> {
	return getOutputOfForeignKey('job_order_id', jobOrderIdList, timeSectionList)
}

/**
 * 获取指定工人在指定时间段内的产量数据。返回值参考 getOutputOfDevice 方法
 */
export async function getOutputOfWorker(workerIdList: string[], timeSectionList: TimeSection[]): Promise<number[][]> {
	return getOutputOfForeignKey('worker_id', workerIdList, timeSectionList)
}

/**
 * 获取指定班次在指定时间段内的产量数据
 * @param dayNight 0 为夜班， 1 为白班。 [0, 1] 表示同时查询白班和夜班。返回值参考 getOutputOfDevice 方法
 */
export async function getOutputOfWorkingShift(workingShiftList: number[], timeSectionList: TimeSection[]) {
	return getOutputOfForeignKey('working_shift', workingShiftList, timeSectionList)
}

// 获取指定车间在指定时间段内的产量数据。返回值参考 getOutputOfDevice 方法
export async function getOutputOfWorkshop(workshopIdList: string[], timeSectionList: TimeSection[]): Promise<number[][]> {
	// 1、查出全部相关机台
	const jtInfoList = await jtInfoRequest.queryAll({
		workshop_id: { $in: workshopIdList },
	})
	const jtIds = jtInfoList.map(jtInfo => jtInfo._id!.$oid)
	// 将jtId 根据 车间进行分组
	const workshopIdToJtIds = jtInfoList.reduce(
		(acc, curr) => {
			acc[curr.workshop_id!].push(curr._id?.$oid)
			return acc
		},
		workshopIdList.reduce((acc, workshopId) => {
			acc[workshopId] = []
			return acc
		}, {} as any)
	)
	const result = await getOutputMapOfForeignKeyWithTimeSection('jt_id', jtIds, timeSectionList)
	// 根据车间的机台分组，对产量数据进行车间汇总
	const workshopOutputDataOfTimeSections = result.map(dataOfTimeSection => {
		return workshopIdList.reduce(
			(acc, workshopId) => {
				const jtIds = workshopIdToJtIds[workshopId] || []
				acc[workshopId] = jtIds.reduce((acc, jtId) => acc + dataOfTimeSection[jtId], 0)
				return acc
			},
			workshopIdList.reduce((acc, workshopId) => {
				acc[workshopId] = 0
				return acc
			}, {} as any)
		)
	})
	return workshopIdList.map(workshopId => workshopOutputDataOfTimeSections.map(outputOfTimeSection => outputOfTimeSection[workshopId]))
}

// 获取指定工艺在指定时间段内的产量数据。返回值参考 getOutputOfDevice 方法
export async function getOutputOfTech(techIdList: string[], timeSectionList: TimeSection[]) {
	const techOutputOfTimeSections: any[] = []
	for (const techId of techIdList) {
		const outputOfTimeSection: any[] = []
		techOutputOfTimeSections.push(outputOfTimeSection)
		for (const timeSection of timeSectionList) {
			const { startTime, endTime } = timeSection
			const defectStatisList = await defectStatisRequest.queryAll(
				{
					[`tech.${techId}`]: 1,
					begin_time: { $gt: { $date: startTime }, $lt: { $date: endTime } },
				},
				{ total_len: 1 },
				undefined,
				1000
			)
			const output = defectStatisList.reduce((acc, curr) => {
				acc += curr.total_len || 0
				return acc
			}, 0)
			outputOfTimeSection.push(output)
		}
	}
	console.log('tech output:', techOutputOfTimeSections)
	return techOutputOfTimeSections
}

/**
 * 张数计算良率，并按照外键进行分组
 */
function transSheetYieldSumValueResult(foreignValueList, sumValueResult) {
	// Insp_count bad_count 来自 defect_statis 中正在进行中的批次数据
	// insp_big_sheet bad_big_sheet  insp_small_sheet bad_small_sheet 来自 real_batch_info 表，是已经完成的批次
	// 良率 = 1 - 坏品张数 / 总张数
	// 总张数 = Insp_count + insp_big_sheet + insp_small_sheet
	// 坏品张数 = bad_count + bad_big_sheet + bad_small_sheet
	return foreignValueList.map(foreignValue =>
		sumValueResult.map(sumValuesOfTimeSection => {
			const sumValues = sumValuesOfTimeSection[foreignValue]
			let { Insp_count, bad_count, insp_big_sheet, bad_big_sheet, insp_small_sheet, bad_small_sheet } = sumValues
			Insp_count = Insp_count || 0
			bad_count = bad_count || 0
			insp_big_sheet = insp_big_sheet || 0
			bad_big_sheet = bad_big_sheet || 0
			insp_small_sheet = insp_small_sheet || 0
			bad_small_sheet = bad_small_sheet || 0
			const totalInsp = Insp_count + insp_big_sheet + insp_small_sheet
			const totalBad = bad_big_sheet + bad_small_sheet

			if (totalInsp === 0) {
				if (totalBad > 0) {
					console.error(`统计结果中，坏张总共为： ${totalBad}，但 总检测张数为 0`)
				}
				return 0
			}
			return (totalInsp - totalBad) / totalInsp
		})
	)
}

/**
 * 通用函数：根据张数计算良率
 */
async function getYieldBySheet(foreignKey: string, foreignValueList: any[], timeSectionList) {
	const result = await getSumValueMapOfForeignKeyWithTimeSection(foreignKey, foreignValueList, ['Insp_count', 'bad_count', 'insp_big_sheet', 'bad_big_sheet', 'insp_small_sheet', 'bad_small_sheet'], timeSectionList)
	console.log(`getYieldBySheet of foreignKey: ${foreignKey}， result：`, result)
	return transSheetYieldSumValueResult(foreignValueList, result)
}

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>   按张数的良率查询函数 start   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  */

// 按张数计算指定机台在指定时间段内的良率。
export async function getYieldOfDevice(jtIdList: string[], timeSectionList: TimeSection[]) {
	return getYieldBySheet('jt_id', jtIdList, timeSectionList)
}

// 按张数计算指定工单在指定时间段内的良率。
export async function getYieldOfWorkOrder(workOrderIdList: string[], timeSectionList: TimeSection[]) {
	return getYieldBySheet('work_order_id', workOrderIdList, timeSectionList)
}

// 按张数计算指定派工单在指定时间段内的良率。
export async function getYieldOfJobOrder(jobOrderIdList: string[], timeSectionList: TimeSection[]) {
	return getYieldBySheet('job_order_id', jobOrderIdList, timeSectionList)
}

/**
 * 获取指定班次在指定时间段内的良率。
 * @param dayNight 0 为夜班， 1 为白班。 [0, 1] 表示同时查询白班和夜班。
 */
export async function getYieldOfShift(workingShiftList: number[], timeSectionList: TimeSection[]) {
	return getYieldBySheet('working_shift', workingShiftList, timeSectionList)
}

// 按张数计算指定车间在指定时间段内的良率。
export async function getYieldOfWorkshop(workshopIdList: string[], timeSectionList: TimeSection[]) {
	// 1、查出全部相关机台
	const jtInfoList = await jtInfoRequest.queryAll({
		workshop_id: { $in: workshopIdList },
	})
	const jtIds = jtInfoList.map(jtInfo => jtInfo._id!.$oid)
	// 将jtId 根据 车间进行分组
	const workshopIdToJtIds = jtInfoList.reduce(
		(acc, curr) => {
			acc[curr.workshop_id!].push(curr._id?.$oid)
			return acc
		},
		workshopIdList.reduce((acc, workshopId) => {
			acc[workshopId] = []
			return acc
		}, {} as any)
	)
	// 根据车间的机台分组，对产量数据进行车间汇总
	const sumKeys = ['Insp_count', 'bad_count', 'insp_big_sheet', 'bad_big_sheet', 'insp_small_sheet', 'bad_small_sheet']
	const result = await getSumValueMapOfForeignKeyWithTimeSection('jt_id', jtIds, sumKeys, timeSectionList)
	/**
	 * result值形如：
	 * [
	 *      // 时间段 1
	 *     {
	 *         jt_id001: {
	 *              sumKey001: 130,
	 *              sumKey002: 140
	 *         },
	 *         jt_id002: {
	 *              sumKey001: 350,
	 *              sumKey002: 270
	 *          }
	 *     },
	 *      // 时间段 2
	 *     {
	 *         jt_id001: {
	 *              sumKey001: 90,
	 *              sumKey002: 40
	 *         },
	 *         jt_id002: {
	 *              sumKey001: 50,
	 *              sumKey002: 20
	 *          }
	 *      }
	 * ]
	 */
	// 对 result 各个部分值根据 workshop 进行分组汇总
	//  return transSheetYieldSumValueResult(foreignValueList, result);
	const workshopSumKeyValuesOfTimeSections = result.map((dataOfTimeSection: any) => {
		return workshopIdList.reduce(
			(acc, workshopId) => {
				const jtIds = workshopIdToJtIds[workshopId] || []
				for (const key of sumKeys) {
					acc[workshopId][key] = jtIds.reduce((acc, jtId) => acc + dataOfTimeSection[jtId][key], 0)
				}
				return acc
			},
			workshopIdList.reduce((acc, workshopId) => {
				acc[workshopId] = sumKeys.reduce((acc, curr) => {
					acc[curr] = 0
					return acc
				}, {} as any)
				return acc
			}, {} as any)
		)
	})
	return transSheetYieldSumValueResult(workshopIdList, workshopSumKeyValuesOfTimeSections)
}

// 按张数计算指定工人在指定时间段内的良率。
export async function getYieldOfWorker(workerIdList: string[], timeSectionList: TimeSection[]) {
	// 获取指定工单，在指定时间段内，计算良率所需要的字段加总值。
	return getYieldBySheet('worker_id', workerIdList, timeSectionList)
}

async function getSumValuesOfTech(techIdList: string[], timeSectionList: TimeSection[], sumKeys: string[], mapSumValue: (sumValues: any) => any) {
	// 接口返回结果中要包含的 key
	const keys = sumKeys.reduce((acc, key) => {
		acc[key] = 1
		return acc
	}, {} as any)
	const techSumValuesOfTimeSections: any[] = []
	for (const techId of techIdList) {
		const resultOfTimeSection: any[] = []
		techSumValuesOfTimeSections.push(resultOfTimeSection)
		for (const timeSection of timeSectionList) {
			const { startTime, endTime } = timeSection
			const defectStatisList = await defectStatisRequest.queryAll(
				{
					[`tech.${techId}`]: 1,
					begin_time: { $gt: { $date: startTime }, $lt: { $date: endTime } },
				},
				{ ...keys, status: 1 },
				undefined,
				1000
			)
			const defectStatisInProcess = defectStatisList.filter(({ status }) => status !== 2)
			// 过滤已完成的批次
			const defectStatisFinished = defectStatisList.filter(({ status }) => status === 2)
			const finishedIds = defectStatisFinished.map(defectStatis => defectStatis._id!.$oid)
			const allSlice = sliceArray(finishedIds, 200)
			const realBatchInfoList = (
				await Promise.all(
					allSlice.map(idListSlice => {
						return realBatchInfoRequest.queryAll(
							{
								roll_id: { $in: idListSlice },
							},
							keys
						)
					})
				)
			).flat()
			// realBatchInfo 和 defectStatis 都存储了一些统计数据，这里直接将二者列表进行混合，可以看作一张总表。对于没有的属性，直接计为 0，对于二者共有的属性，可以直接加总
			const sumValues = [...defectStatisInProcess, ...realBatchInfoList].reduce(
				(acc: any, curr: any) => {
					console.log('defect statis data:', curr)
					for (const key of sumKeys) {
						console.log('key & value of defectStatis data:', key, '==>', curr[key])
						try {
							acc[key] += curr[key] || 0
						} catch (e) {
							debugger
						}
					}
					return acc
				},
				sumKeys.reduce((acc, curr) => {
					acc[curr] = 0
					return acc
				}, {} as any)
			)
			console.log('sumValues:', sumValues)
			const result = mapSumValue(sumValues)
			resultOfTimeSection.push(result)
		}
	}
	console.log('techSumValuesOfTimeSections:', techSumValuesOfTimeSections)
	return techSumValuesOfTimeSections
}

// 按张数计算指定工艺在指定时间段内的良率。
export async function getYieldOfTech(techIdList: string[], timeSectionList: TimeSection[]) {
	const result = await getSumValuesOfTech(techIdList, timeSectionList, ['Insp_count', 'bad_count', 'insp_big_sheet', 'bad_big_sheet', 'insp_small_sheet', 'bad_small_sheet'], (sumValues: any) => {
		let { Insp_count, bad_count, insp_big_sheet, bad_big_sheet, insp_small_sheet, bad_small_sheet } = sumValues
		Insp_count = Insp_count || 0
		bad_count = bad_count || 0
		insp_big_sheet = insp_big_sheet || 0
		bad_big_sheet = bad_big_sheet || 0
		insp_small_sheet = insp_small_sheet || 0
		bad_small_sheet = bad_small_sheet || 0
		const totalInsp = Insp_count + insp_big_sheet + insp_small_sheet
		const totalBad = bad_big_sheet + bad_small_sheet

		if (totalInsp === 0) {
			if (totalBad > 0) {
				console.error(`统计结果中，坏张总共为： ${totalBad}，但 总检测张数为 0`)
			}
			return 0
		}
		return (totalInsp - totalBad) / totalInsp
	})
	return result
}

/** <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<   按张数的良率查询函数 end   <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<  */

/**
 * 米数良率计算，并按照外键值进行分组
 */
function transMeterYieldSumValueResult(foreignValueList: any[], sumValueResult: any[]) {
	return foreignValueList.map(foreignValue =>
		sumValueResult.map(sumValuesOfTimeSection => {
			const sumValues = sumValuesOfTimeSection[foreignValue]
			const {
				total_len, // 总长度
				bad_len_printer, // 印刷缺陷长度
				bad_len_qa, // QA确认缺陷长度
				bad_len, // 缺陷长度
			} = sumValues
			const totalInsp = total_len || 0
			const badLenInProcess = bad_len_qa || bad_len_printer
			const totalBad = bad_len + badLenInProcess

			if (totalInsp === 0) {
				if (totalBad > 0) {
					console.error(`统计结果中，总缺陷长度共为： ${totalBad}，但 总检测米数为 0`)
				}
				return 0
			}
			return (totalInsp - totalBad) / totalInsp
		})
	)
}

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>   按米数的良率查询函数 start   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  */

// 通用函数：根据米数计算良率
async function getYieldByMeter(foreignKey: string, foreignValueList: any[], timeSectionList) {
	const result = await getSumValueMapOfForeignKeyWithTimeSection(foreignKey, foreignValueList, ['total_len', 'bad_Len_qa_judgement', 'bad_len_qa', 'bad_len_printer', 'bad_len'], timeSectionList)
	console.log(`getYieldBySheet of foreignKey: ${foreignKey}， result：`, result)
	return transMeterYieldSumValueResult(foreignValueList, result)
}

// 获取机台按米数计算的良率
export async function getMeterYieldOfDevice(jtIdList: string[], timeSectionList: TimeSection[]) {
	return getYieldByMeter('jt_id', jtIdList, timeSectionList)
}

// 获取工单按米数计算的良率
export async function getMeterYieldOfJobOrder(jobOrderIdList: string[], timeSectionList: TimeSection[]) {
	return getYieldByMeter('job_order_id', jobOrderIdList, timeSectionList)
}

// 获取班次按米数计算的良率。
export async function getMeterYieldOfWorkingShift(workingShiftList: number[], timeSectionList: TimeSection[]) {
	return getYieldByMeter('working_shift', workingShiftList, timeSectionList)
}

// 获取车间按米数计算的良率。
export async function getMeterYieldOfWorkshop(workshopIdList: string[], timeSectionList: TimeSection[]) {
	return getYieldByMeter('workshop_id', workshopIdList, timeSectionList)
}
// 获取工人按米数计算的良率。
export async function getMeterYieldOfWorker(workerIdList: string[], timeSectionList: TimeSection[]) {
	return getYieldByMeter('worker_id', workerIdList, timeSectionList)
}

// 获取工艺按米数计算的良率。
export async function getMeterYieldOfTech(techIdList: string[], timeSectionList: TimeSection[]) {
	const result = await getSumValuesOfTech(techIdList, timeSectionList, ['total_len', 'bad_Len_qa_judgement', 'bad_len_qa', 'bad_len_printer', 'bad_len'], (sumValues: any) => {
		const {
			total_len, // 总长度
			bad_len_printer, // 印刷缺陷长度
			bad_len_qa, // QA确认缺陷长度
			bad_len, // 缺陷长度
		} = sumValues
		const totalInsp = total_len || 0
		const badLenInProcess = bad_len_qa || bad_len_printer
		const totalBad = bad_len + badLenInProcess

		if (totalInsp === 0) {
			if (totalBad > 0) {
				console.error(`统计结果中，总缺陷长度共为： ${totalBad}，但 总检测米数为 0`)
			}
			return 0
		}
		return (totalInsp - totalBad) / totalInsp
	})
	return result
}
/** <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<   按米数的良率查询函数 end   <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<  */

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>   调机时间统计 start   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  */
async function getAdjustTimeOfForeignKey(foreignKey, foreignIdList: any[], timeSectionList: TimeSection[]) {
	const result = await Promise.all(
		timeSectionList.map(async ({ startTime, endTime }) => {
			const defectStatisList = await defectStatisRequest.queryAll(
				{
					[foreignKey]: { $in: foreignIdList },
					is_adjust: 1,
					begin_time: { $gt: { $date: startTime }, $lt: { $date: endTime } },
				},
				{ [foreignKey]: 1, begin_time: 1, end_time: 1 },
				undefined,
				1000
			)
			return defectStatisList.reduce(
				(acc, curr) => {
					const { begin_time, end_time } = curr
					if (!begin_time || !end_time) {
						return acc
					}
					const foreignId = curr[foreignKey]
					if (foreignId) {
						acc[foreignId] += end_time.$date - begin_time.$date
					}
					return acc
				},
				foreignIdList.reduce((acc, foreignId) => {
					acc[foreignId] = 0
					return acc
				}, {} as any)
			)
		})
	)
	return foreignIdList.map(foreignId => result.map(outputOfTimeSection => outputOfTimeSection[foreignId]))
}

// 统计某设备在指定时间段内的调机时间，单位毫秒
export function getAdjustTimeOfDevice(jtIdList: string[], timeSectionList: TimeSection[]) {
	return getAdjustTimeOfForeignKey('jt_id', jtIdList, timeSectionList)
}

// 按张数计算指定工单在指定时间段内的调机时间，单位毫秒
export async function getAdjustTimeOfWorkOrder(workOrderIdList: string[], timeSectionList: TimeSection[]) {
	return getAdjustTimeOfForeignKey('work_order_id', workOrderIdList, timeSectionList)
}

// 按张数计算指定派工单在指定时间段内的调机时间，单位毫秒
export async function getAdjustTimeOfJobOrder(jobOrderIdList: string[], timeSectionList: TimeSection[]) {
	return getAdjustTimeOfForeignKey('job_order_id', jobOrderIdList, timeSectionList)
}

/**
 * 获取指定班次在指定时间段内的调机时间，单位毫秒
 * @param dayNight 0 为夜班， 1 为白班。 [0, 1] 表示同时查询白班和夜班。
 */
export async function getAdjustTimeOfShift(workingShiftList: number[], timeSectionList: TimeSection[]) {
	return getAdjustTimeOfForeignKey('working_shift', workingShiftList, timeSectionList)
}

// 获取车间按米数计算的调机时间，单位毫秒
export async function getAdjustTimeOfWorkshop(workshopIdList: string[], timeSectionList: TimeSection[]) {
	return getAdjustTimeOfForeignKey('workshop_id', workshopIdList, timeSectionList)
}

// 获取工人按米数计算的调机时间，单位毫秒
export async function getAdjustTimeOfWorker(workerIdList: string[], timeSectionList: TimeSection[]) {
	return getAdjustTimeOfForeignKey('worker_id', workerIdList, timeSectionList)
}

// 获取工艺按米数计算的调机时间，单位毫秒
export async function getAdjustTimeOfTech(techIdList: string[], timeSectionList: TimeSection[]) {
	const techTimeOfTimeSections: any[] = []
	for (const techId of techIdList) {
		const timeOfTimeSection: any[] = []
		techTimeOfTimeSections.push(timeOfTimeSection)
		for (const timeSection of timeSectionList) {
			const { startTime, endTime } = timeSection
			const defectStatisList = await defectStatisRequest.queryAll(
				{
					[`tech.${techId}`]: 1,
					is_adjust: 1,
					begin_time: { $gt: { $date: startTime }, $lt: { $date: endTime } },
				},
				{ begin_time: 1, end_time: 1 },
				undefined,
				1000
			)
			const time = defectStatisList.reduce((acc, curr) => {
				const { begin_time, end_time } = curr
				if (!begin_time || !end_time) {
					return acc
				}
				acc += end_time.$date - begin_time.$date
				return acc
			}, 0)
			timeOfTimeSection.push(time)
		}
	}
	return techTimeOfTimeSections
}

/** <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<   调机时间统计 end   <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<  */

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>   调机米数统计 start   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  */
async function getAdjustMeterOfForeignKey(foreignKey, foreignIdList: any[], timeSectionList: TimeSection[]) {
	const result = await Promise.all(
		timeSectionList.map(async ({ startTime, endTime }) => {
			const defectStatisList = await defectStatisRequest.queryAll(
				{
					[foreignKey]: { $in: foreignIdList },
					is_adjust: 1,
					begin_time: { $gt: { $date: startTime }, $lt: { $date: endTime } },
				},
				{ [foreignKey]: 1, total_len: 1 },
				undefined,
				1000
			)
			return defectStatisList.reduce(
				(acc, curr) => {
					const { total_len } = curr
					if (!total_len) {
						return acc
					}
					const foreignId = curr[foreignKey]
					if (foreignId) {
						acc[foreignId] += total_len
					}
					return acc
				},
				foreignIdList.reduce((acc, foreignId) => {
					acc[foreignId] = 0
					return acc
				}, {} as any)
			)
		})
	)
	return foreignIdList.map(foreignId => result.map(outputOfTimeSection => outputOfTimeSection[foreignId]))
}

// 统计某设备在指定时间段内的调机米数，单位毫秒
export function getAdjustMeterOfDevice(jtIdList: string[], timeSectionList: TimeSection[]) {
	return getAdjustMeterOfForeignKey('jt_id', jtIdList, timeSectionList)
}

// 按张数计算指定工单在指定时间段内的调机米数，单位毫秒
export async function getAdjustMeterOfWorkOrder(workOrderIdList: string[], timeSectionList: TimeSection[]) {
	return getAdjustMeterOfForeignKey('work_order_id', workOrderIdList, timeSectionList)
}

// 按张数计算指定派工单在指定时间段内的调机米数，单位毫秒
export async function getAdjustMeterOfJobOrder(jobOrderIdList: string[], timeSectionList: TimeSection[]) {
	return getAdjustMeterOfForeignKey('job_order_id', jobOrderIdList, timeSectionList)
}

/**
 * 获取指定班次在指定时间段内的调机米数，单位毫秒
 * @param dayNight 0 为夜班， 1 为白班。 [0, 1] 表示同时查询白班和夜班。
 */
export async function getAdjustMeterOfShift(workingShiftList: number[], timeSectionList: TimeSection[]) {
	return getAdjustMeterOfForeignKey('working_shift', workingShiftList, timeSectionList)
}

// 获取车间按米数计算的调机米数，单位毫秒
export async function getAdjustMeterOfWorkshop(workshopIdList: string[], timeSectionList: TimeSection[]) {
	return getAdjustMeterOfForeignKey('workshop_id', workshopIdList, timeSectionList)
}

// 获取工人按米数计算的调机米数，单位毫秒
export async function getAdjustMeterOfWorker(workerIdList: string[], timeSectionList: TimeSection[]) {
	return getAdjustMeterOfForeignKey('worker_id', workerIdList, timeSectionList)
}

// 获取工艺按米数计算的调机米数，单位毫秒
export async function getAdjustMeterOfTech(techIdList: string[], timeSectionList: TimeSection[]) {
	const techAdjustMeterOfTimeSections: any[] = []
	for (const techId of techIdList) {
		const AdjustMeterOfTimeSection: any[] = []
		techAdjustMeterOfTimeSections.push(AdjustMeterOfTimeSection)
		for (const timeSection of timeSectionList) {
			const { startTime, endTime } = timeSection
			const defectStatisList = await defectStatisRequest.queryAll(
				{
					[`tech.${techId}`]: 1,
					is_adjust: 1,
					begin_time: { $gt: { $date: startTime }, $lt: { $date: endTime } },
				},
				{ total_len: 1 },
				undefined,
				1000
			)
			const meter = defectStatisList.reduce((acc, curr) => {
				const { total_len } = curr
				if (!total_len) {
					return acc
				}
				acc += total_len
				return acc
			}, 0)
			AdjustMeterOfTimeSection.push(meter)
		}
	}
	return techAdjustMeterOfTimeSections
}

/** <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<   调机米数统计 end   <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<  */

/** <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<   缺陷类型统计 start   <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<  */

// 查询指定批次的缺陷分布，返回一个数组，每一项为一个缺陷类型的统计对象，该对象包含一个count字段，表示它的统计计数结果，另外还包含一个 defectType 字段，为该缺陷类型的相关信息。
async function getDefectStatisDefectTypeCount(defectStatisId: string) {
	const defect_request = getDefectRequest(defectStatisId)
	try {
		await defect_request.addPipeline(
			[
				{
					$group: {
						_id: '$type_index',
						count: { $sum: 1 },
					},
				},
			],
			'defectTypeCount',
			true
		)
	} catch (e) {
		return null
	}
	const {
		data: { _embedded },
	} = await defect_request.aggregateQuery('defectTypeCount')
	console.log(`defect_request.aggregateQuery('defectTypeCount') ===>`, _embedded)
	const typeIndexes = _embedded.map(typeCount => typeCount._id)
	const defectTypes = await defectTypeRequest.queryAll({
		roll_id: defectStatisId,
		type_index: { $in: typeIndexes },
	})
	console.log(`defectStatisId: ${defectStatisId} defectTypes: `, defectTypes)
	const typeIndexToTypeMap = defectTypes.reduce((acc, curr) => {
		acc[curr.type_index!] = curr
		return acc
	}, {} as any)
	return _embedded.map(({ _id, count }) => {
		const defectType = typeIndexToTypeMap[_id]
		if (defectType) {
			return {
				// 有缺陷类型信息时，返回结果中把这些信息包含进去
				display: defectType.display,
				name: defectType.name,
				type_index: _id,
				count,
				defectStatisId,
			}
		} else {
			return {
				// 没有缺陷类型信息时，则只包含一个 type_index
				count,
				type_index: _id,
				defectStatisId,
			}
		}
	})
}
// 查询指定外键在指定时间段内的缺陷类型个数统计，结果对象中，key 为外键的值，value为一个数组，其中每一项为
async function getDefectTypeCountOfForeignKey(foreignKey, foreignIdList: any[], timeSection: TimeSection) {
	const { startTime, endTime } = timeSection
	const defectStatisList = await defectStatisRequest.queryAll(
		{
			[foreignKey]: { $in: foreignIdList },
			begin_time: { $gt: { $date: startTime }, $lt: { $date: endTime } },
		},
		{ [foreignKey]: 1 },
		undefined,
		1000
	)
	const defectStatisIds = defectStatisList.map(defectStatis => defectStatis._id!.$oid) // 全部批次id
	// 批次id 到 外键值 的映射
	const defectStatisIdToForeignId = defectStatisList.reduce((acc, curr) => {
		const { _id } = curr
		const $oid = _id!.$oid
		acc[$oid] = curr[foreignKey]
		return acc
	}, {} as any)
	// 分别查询这些批次的缺陷类型统计
	const requetPool: Promise<any>[] = [] // 请求池，允许并发请求
	const poolSize = 10 // 并发数
	// 结果集，该对象key为外键值，value为一个数组，包含该外键对应的全部批次的缺陷类型统计对象
	const resultMap = foreignIdList.reduce((acc, curr) => {
		acc[curr] = []
		return acc
	}, {} as any)
	for (let i = 0; i < defectStatisIds.length; i++) {
		// defectStatisId of
		const position = i % poolSize
		const task = async () => {
			const defectStatisId = defectStatisIds[i]
			const defectTypeCountList = await getDefectStatisDefectTypeCount(defectStatisId) // 查询批次中包含的缺陷类型的个数，返回一个数组，每一项是一个缺陷类型信息和它的个数
			if (defectTypeCountList && defectTypeCountList.length > 0) {
				for (const count of defectTypeCountList) {
					resultMap[defectStatisIdToForeignId[defectStatisId]].push(count)
				}
			}
		}
		if (requetPool[position]) {
			requetPool[position] = requetPool[position].then(task)
		} else {
			requetPool[position] = task()
		}
	}
	await Promise.all(requetPool) // 全部任务完成
	return resultMap
}

// 统计某设备在指定时间段内的缺陷类型个数
export function getDefectTypeCountOfDevice(jtIdList: string[], timeSection: TimeSection) {
	return getDefectTypeCountOfForeignKey('jt_id', jtIdList, timeSection)
}

// 统计指定工单在指定时间段内的缺陷类型个数
export async function getDefectTypeCountOfWorkOrder(workOrderIdList: string[], timeSection: TimeSection) {
	return getDefectTypeCountOfForeignKey('work_order_id', workOrderIdList, timeSection)
}

// 统计指定派工单在指定时间段内的缺陷类型个数
export async function getDefectTypeCountOfJobOrder(jobOrderIdList: string[], timeSection: TimeSection) {
	return getDefectTypeCountOfForeignKey('job_order_id', jobOrderIdList, timeSection)
}

/**
 * 统计指定班次在指定时间段内的缺陷类型个数
 * @param dayNight 0 为夜班， 1 为白班。 [0, 1] 表示同时查询白班和夜班。
 */
export async function getDefectTypeCountOfShift(workingShiftList: number[], timeSection: TimeSection) {
	return getDefectTypeCountOfForeignKey('working_shift', workingShiftList, timeSection)
}

// 统计车间在指定时间段内的缺陷类型个数
export async function getDefectTypeCountOfWorkshop(workshopIdList: string[], timeSection: TimeSection) {
	return getDefectTypeCountOfForeignKey('workshop_id', workshopIdList, timeSection)
}

// 统计工人在指定时间段内的缺陷类型个数
export async function getDefectTypeCountOfWorker(workerIdList: string[], timeSection: TimeSection) {
	const result = getDefectTypeCountOfForeignKey('worker_id', workerIdList, timeSection)
	console.log('result of getDefectTypeCountOfWorker: ', result)
	return result
}

// 统计工艺在指定时间段内的缺陷类型个数
export async function getDefectTypeCountOfTech(techIdList: string[], timeSection: TimeSection) {
	const techDefectTypeCountOfTimeSections: any = {}
	for (const techId of techIdList) {
		// 结果集，全部批次的缺陷类型统计对象
		const defectTypeCountOfTimeSection: any[] = []
		techDefectTypeCountOfTimeSections[techId] = defectTypeCountOfTimeSection

		const { startTime, endTime } = timeSection
		const defectStatisList = await defectStatisRequest.queryAll(
			{
				[`tech.${techId}`]: 1,
				begin_time: { $gt: { $date: startTime }, $lt: { $date: endTime } },
			},
			{ begin_time: 1 },
			undefined,
			1000
		)
		const defectStatisIds = defectStatisList.map(defectStatis => defectStatis._id!.$oid) // 全部批次id
		console.log('tech id: ', techId, '\ndefectStatisIds: ', defectStatisIds)
		// 分别查询这些批次的缺陷类型统计
		const requetPool: Promise<any>[] = [] // 请求池，允许并发请求
		const poolSize = 10 // 并发数
		for (let i = 0; i < defectStatisIds.length; i++) {
			// defectStatisId of
			const position = i % poolSize
			const task = async () => {
				const defectStatisId = defectStatisIds[i]
				const defectTypeCountList = await getDefectStatisDefectTypeCount(defectStatisId) // 查询批次中包含的缺陷类型的个数，返回一个数组，每一项是一个缺陷类型信息和它的个数
				if (defectTypeCountList && defectTypeCountList.length > 0) {
					for (const count of defectTypeCountList) {
						defectTypeCountOfTimeSection.push(count)
					}
				}
			}
			if (requetPool[position]) {
				requetPool[position] = requetPool[position].then(task)
			} else {
				requetPool[position] = task()
			}
		}
		await Promise.all(requetPool) // 全部任务完成
	}
	console.log('result of techDefectTypeCountOfTimeSections: ', techDefectTypeCountOfTimeSections)
	return techDefectTypeCountOfTimeSections
}
/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>   缺陷类型统计 end   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  */

/**
 * 查询指定批次的良率，按张数计算
 * @param defectStatisIdList 批次id列表
 */
export async function getYieldOfDefectStatis(defectStatisIdList: string[]) {
	const defectStaticsList = await defectStatisRequest.queryByIds(defectStatisIdList)
	return defectStaticsList.map(defectStatis => {
		const { Insp_count, bad_count } = defectStatis
		if (Insp_count === null || Insp_count === undefined) {
			console.error('Insp_count has no value, defectStatis data:', defectStatis)
			return 0
		}
		if (bad_count === null || bad_count === undefined) {
			console.error('Insp_count has no value, defectStatis data:', defectStatis)
			return 0
		}
		if (Insp_count === 0) {
			console.error('Insp_count equals to zero, defectStatis data:', defectStatis)
			return 0
		}
		return (Insp_count - bad_count) / Insp_count
	})
}

/**
 * 查询批次缺陷统计
 * @param defectStatisId 批次id
 */

export async function getDefectOfDefectStatis(defectStatisId: string) {
	var defectRequest = getDefectRequest(defectStatisId)

	var result: any[] = []
	//获取所有的缺陷记录。
	var array = await defectRequest.queryAll()
	//获取所有的缺陷类型。
	var defectTypes = await defectTypeRequest.queryAll({ roll_id: defectStatisId })

	var stat_item: any = {}
	for (var v of array) {
		console.log('遍历缺陷类型：', v.type_index)
		//获取缺陷类型。
		var typeName = defectTypes.find(t => t.type_index == v.type_index)?.display
		if (!typeName) continue

		if (typeName in stat_item) {
			stat_item[typeName!] += 1
		} else {
			stat_item[typeName!] = 1
		}
	}

	stat_item.jt_name = '' // jtInfo.name
	stat_item.jt_id = ''
	result.push(stat_item)

	return result
}

/**
 * 米数合并。
 * @param array
 */
function meterMerge(array: any[], targetLength = 20) {}

/**
 * 查询工单颜色信息
 *  @param orderId 工单id
 *  @param callback 回调函数。
 */
export async function getColorInfoOfOrdId(job_order_id: string, callback) {
	console.log('查询工单颜色信息', job_order_id)

	if (!job_order_id) {
		return {
			chartData: {
				columns: ['米数', '阈值', '良率'],
				rows: [],
			},
			totalLen: 0,
		}
	}

	//根据工单获取所有批次。
	var job_order_defects_statis = await defectStatisRequest.queryAll({ job_order_id: job_order_id }, { _id: 1, roll_code: 1, total_len: 1 }, { _id: 1 }, 1000)
	//map到工单批次的所有Id。
	var job_order_defects_statis_id_array = job_order_defects_statis.map(t => t._id?.$oid)

	console.log('工单所有批次', job_order_defects_statis_id_array)

	//获取批次下面所有的颜色信息。
	var colorInfos = await colorInfoRequest.queryAll({ roll_id: $in(job_order_defects_statis_id_array) })

	//获取米数和良率的关联。
	var yieldRate = (await getMeterYieldByJobOrderId(job_order_id)) as any[]

	var default_delta_e_threshold = 0

	//遍历工单
	var array: any[] = []
	var total_len = 0
	var totalCount = job_order_defects_statis_id_array.length
	var completeCount = 0

	for (const d of job_order_defects_statis_id_array) {
		var existDefectStatis = job_order_defects_statis.find(t => t._id?.$oid == d)
		if (existDefectStatis) {
			var percentage = (completeCount / totalCount) * 100
			callback(`分析进度：${percentage.toFixed(2)}%,正在处理批次：${existDefectStatis.roll_code}`)

			total_len += existDefectStatis.total_len
		}

		//获取批次下所有色块值信息,按照位置进行正序排列。
		var colors = await getColorRequest(d!).queryAll(undefined, undefined, { meter: 1 }, 1000)

		var last_meter = 0
		if (array.length > 0) {
			last_meter = array[array.length - 1].meter
		}

		var last_delta_e = 0
		for (const c of colors) {
			var colorInfo = colorInfos.find(p => p._id?.$oid == c.color_info_id)

			//处理一下色差值：-1按前一个值显示，超过30按30显示。
			var delta_e = c.delta_e!
			if (delta_e < 0) {
				delta_e = last_delta_e
			} else if (delta_e > 30) {
				delta_e = 30
			}

			var item = {
				name: colorInfo?.name,
				meter: last_meter + c.meter! / 1000,
				delta_e: delta_e,
				threshold: colorInfo?.delta_e_threshold,
			}

			last_delta_e = delta_e

			if (default_delta_e_threshold == 0) default_delta_e_threshold = colorInfo?.delta_e_threshold ?? 0

			array.push(item)
		}

		completeCount++
	}

	callback('批次处理完成，正在生成统计数据...')

	array = array.sort((a, b) => {
		return a.meter - b.meter
	})

	//获取所有色块名称。
	const color_block_items = colorInfos
		.map(t => t.name!)
		.reduce((all, cur) => {
			if (!all.includes(cur)) {
				all.push(cur)
			}

			return all
		}, [] as any)

	//获取所有的米数
	const all_meter = array
		.map(t => t.meter!)
		.reduce((all, cur) => {
			if (!all.includes(cur)) {
				all.push(cur)
			}
			return all
		}, [] as any)

	var chartData: any = {
		columns: ['米数', '阈值2', '良率'].concat(color_block_items),
		rows: [],
	}
	var sumMeters = 0
	all_meter.forEach(element => {
		var items = array.filter(t => t.meter == element)
		sumMeters += element

		//找最接近该米数的良率值。
		var mapedRateList = yieldRate.map(t => {
			return {
				sort: Math.abs(element - t.meter / 1000),
				rate: t.yieldOfMeter,
			}
		})

		var rate = mapedRateList.sort((a, b) => {
			return a.sort - b.sort
		})[0].rate as number

		var obj = {
			米数: element,
			阈值2: default_delta_e_threshold,
			良率: rate,
		}

		for (const v of color_block_items) {
			var d = items.find(t => t.name == v)
			var value = 0
			if (d) {
				value = d.delta_e
			}
			obj[v] = value
		}

		chartData.rows.push(obj)
	})

	//console.log('array', array)
	//console.log('chartData', chartData)
	//console.log('all_meter', all_meter)

	return {
		chartData: chartData,
		totalLen: total_len,
	}
}

/**
 * 查询工单工艺统计信息
 *  @param orderId 工单Id。
 *  @param callback 回调函数，用来显示进度。
 */
export async function getTechStatByJobOrderId(job_order_id: string, callback) {
	callback(`获取工单基本信息...`)
	//根据工单获取所有批次。
	var job_order_defects_statis = await defectStatisRequest.queryAll({ job_order_id: job_order_id }, { _id: 1, jt_id: 1, roll_code: 1, total_len: 1 }, { _id: 1 }, 1000)
	//map到工单批次的所有Id。
	var job_order_defects_statis_id_array = job_order_defects_statis.map(t => t._id?.$oid)

	callback(`获取所有工艺信息...`)
	//获取所有的工艺信息。
	var tech_list = await techInfoRequest.queryAll()

	callback(`正在获取良率...`)
	//获取米数和良率的关联。
	var yieldRate = (await getMeterYieldByJobOrderId(job_order_id)) as any[]

	//遍历工单
	var array: any[] = []
	var total_len = 0
	var totalCount = job_order_defects_statis_id_array.length
	var completeCount = 0

	//遍历批次集合，获取所有工艺值。
	for (const d of job_order_defects_statis_id_array) {
		var existDefectStatis = job_order_defects_statis.find(t => t._id?.$oid == d)
		if (existDefectStatis) {
			var percentage = (completeCount / totalCount) * 100
			callback(`分析进度：${percentage.toFixed(2)}%,正在处理批次：${existDefectStatis.roll_code}`)

			var jt_id = existDefectStatis?.jt_id!
			var tech_id_list: any[] = []

			//判断机台是否有效。
			if (jt_id) {
				//获取机台信息。
				var jtInfo = (await await jtInfoRequest.getDocumentById(jt_id)).data as jt_info
				//取机台的工艺组Id。
				var jt_tech_groupId = jtInfo.tech_group_id
				if (jt_tech_groupId) {
					//获取工艺组详情。
					var techGroupDetails = (await techGroupDetailRequest.queryAll({ tech_group_id: jt_tech_groupId })) as tech_group_detail[]
					//获取工艺组下的所有工艺Id。
					tech_id_list = techGroupDetails.map(t => t.tech_id)

					//接收当前工艺组的工艺。
					var existTechs: tech_info[] = []
					//遍历所有工艺，检查工艺是否属于当前机台。
					tech_list.forEach(t => {
						if (tech_id_list.indexOf(t._id?.$oid!) > -1) {
							existTechs.push(t)
						}
					})

					//工艺列表重新赋值给当前机台配置的工艺组下面的工艺。
					tech_list = existTechs
				}
			}
			total_len += existDefectStatis.total_len
		}

		//获取批次下所有工艺值,按照位置进行正序排列。
		var techs = await getTechRequest(d!).queryAll(undefined, undefined, { meter: 1 }, 1000)

		var last_meter = 0
		if (array.length > 0) {
			last_meter = array[array.length - 1].meter
		}

		//遍历所有工艺，取：工艺参数值的最大值和最小值（这里不从techInfo中获取，需要从工艺参数运行表统计出来）。
		var temp_tech_list: any[] = []
		tech_list.forEach(techInfo => {
			var values = techs.filter(t => t.tech_id == techInfo._id?.$oid).map(t => t.value!)
			var max = Math.max.apply(null, values)
			var min = Math.min.apply(null, values)
			temp_tech_list.push({ ...techInfo, max1: max, min1: min })
		})

		for (const c of techs) {
			var techInfo = temp_tech_list.find(p => p._id?.$oid == c.tech_id)

			//归一化到100。
			var val = (c.value! - techInfo?.min1!) / (techInfo?.max1! - techInfo?.min1!)
			//console.log('归一化到100', techInfo, c, val, val * 100)

			var item = {
				name: techInfo?.name,
				meter: last_meter + c.meter! / 1000,
				value: (val * 100).toFixed(2),
				original: c.value,
			}

			array.push(item)
		}
	}

	callback('批次处理完成，正在生成统计数据...')

	array = array.sort((a, b) => {
		return a.meter - b.meter
	})

	//获取所有工艺名称，并进行去重。
	const techNames = tech_list
		.map(t => t.name!)
		.reduce((all, cur) => {
			if (!all.includes(cur)) {
				all.push(cur)
			}

			return all
		}, [] as any)

	//获取所有的米数
	var all_meter = array
		.map(t => t.meter!)
		.reduce((all, cur) => {
			if (!all.includes(cur)) {
				all.push(cur)
			}
			return all
		}, [] as any)

	// yieldRate.forEach(element => {
	// 	if (element.meter in all_meter == false) {
	// 		all_meter.push(element.meter)
	// 	}
	// })

	var chartData: any = {
		columns: ['米数', '良率'].concat(techNames),
		rows: [],
	}

	//按照米数排序。
	all_meter = all_meter.sort((a, b) => {
		return a - b
	})

	all_meter.forEach(element => {
		var items = array.filter(t => t.meter == element)
		//找最接近该米数的良率值。
		var mapedRateList = yieldRate.map(t => {
			return {
				sort: Math.abs(element - t.meter / 1000),
				rate: t.yieldOfMeter,
			}
		})

		var rate = mapedRateList.sort((a, b) => {
			return a.sort - b.sort
		})[0].rate as number

		// var yr = yieldRate.find(t => t.meter / 1000 == element)
		// var rate = yieldRate[0].yieldOfMeter
		// if (yr) {
		// 	rate = yr.yieldOfMeter
		// }

		var obj = {
			米数: element,
			良率: rate.toFixed(4),
		}

		for (const v of techNames) {
			var d = items.find(t => t.name == v)
			var value = 0
			var original = 0
			if (d) {
				value = d.value
				original = d.original
			}

			console.log('1166 set', v, value, obj)

			obj[v] = {
				value,
				original,
			}
		}

		chartData.rows.push(obj)
	})

	return {
		totalLen: total_len,
		chartData: chartData,
	}
}

/**
 * 查询批次的工艺统计信息。
 *  @param defect_statis_id 批次Id。
 */
export async function getTechStatByDefectStatisId(defect_statis_id: string) {
	//获取所有工艺信息。
	var tech_list = await techInfoRequest.queryAll()

	var defectStatis = (await defectStatisRequest.getDocumentById(defect_statis_id)).data

	//所有工艺位置信息。
	var array: any[] = []

	//获取批次下所有工艺值,按照位置进行正序排列。
	var techs = await getTechRequest(defect_statis_id).queryAll(undefined, undefined, { meter: 1 }, 1000)

	//获取米数和良率的关联。
	var yieldRate = (await getMeterYieldByDefectStatisList([defectStatis])) as any[]

	console.log(yieldRate)
	//遍历所有工艺位置信息。
	for (const c of techs) {
		//获取工艺信息。
		var techInfo = tech_list.find(p => p._id?.$oid == c.tech_id)
		if (techInfo) {
			//归一化到100。
			var val = (c.value! - techInfo?.min!) / (techInfo?.max! - techInfo?.min!)

			var item = {
				name: techInfo?.name,
				meter: c.meter!,
				value: val * 100,
			}

			array.push(item)
		}
	}

	array = array.sort((a, b) => {
		return a.meter - b.meter
	})

	//获取所有工艺名称，并进行去重。
	const tech_names = tech_list
		.map(t => t.name!)
		.reduce((all, cur) => {
			if (!all.includes(cur)) {
				all.push(cur)
			}

			return all
		}, [] as any)

	//获取所有的米数
	var all_meter = array
		.map(t => t.meter!)
		.reduce((all, cur) => {
			if (!all.includes(cur)) {
				all.push(cur)
			}
			return all
		}, [] as any)

	// yieldRate.forEach(element => {
	// 	if (element.meter in all_meter == false) {
	// 		all_meter.push(element.meter)
	// 	}
	// })

	var chartData: any = {
		columns: ['米数', '良率'].concat(tech_names),
		rows: [],
	}
	var sumMeters = 0
	var lastValue = 0

	//按照米数排序。
	all_meter = all_meter.sort((a, b) => {
		return a - b
	})

	//遍历所有米数。
	all_meter.forEach(element => {
		//获取米数对应的工艺参数。
		var items = array.filter(t => t.meter == element)
		sumMeters += element

		//找最接近该米数的良率值。
		var mapedRateList = yieldRate.map(t => {
			return {
				sort: Math.abs(element - t.meter / 1000),
				rate: t.yieldOfMeter,
			}
		})

		var rate = mapedRateList.sort((a, b) => {
			return a.sort - b.sort
		})[0].rate as number

		var obj = {
			米数: element / 1000,
			良率: rate,
		}
		for (const v of tech_names) {
			var d = items.find(t => t.name == v)
			//var lastValue = 0

			//如果没有值，延续上一次的工艺参数值。
			if (d) {
				lastValue = d.value
			}

			obj[v] = lastValue
		}

		//console.log('米数', element, '良率', rate * 100)

		chartData.rows.push(obj)
	})

	return {
		chartData: chartData,
	}
}

/**
 * 测试
 */
export async function test() {
	const defectStatisList = await defectStatisRequest.queryAll()
	const defectStatisIdList = defectStatisList.map(defectStatis => defectStatis._id!.$oid)
	const getValuesOfKey = (key: string, dataList: object[]) => {
		return [...new Set(dataList.map(data => data[key]))]
	}
	// 机台样本
	// const jtIds: string[] = getValuesOfKey('jt_id', defectStatisList);
	const jtIds = ['5f3b65ea8e936ec4459889cc', '5f059f8753a6df8961543554', '5f0520a053a6df896153f19f']
	console.log('sample jtIds:', jtIds)
	// 工单样本
	const workOrderIds: string[] = getValuesOfKey('work_order_id', defectStatisList)
	console.log('sample workOrderIds:', workOrderIds)
	// 车间样本
	const workshopList = await workshopRequest.queryAll()
	const workshopIds = workshopList.map(workshop => workshop._id!.$oid)
	// 时间段样本
	const timeSectionList = [
		{
			startTime: 1095990041000,
			endTime: 3599895400000,
		},
		// {
		//     startTime: 1595894400000,
		//     endTime: 1596497768515
		// }
	]

	// // 查询批次张数良率
	// const result0 = await getYieldOfDefectStatis(defectStatisIdList.slice(0, 10));
	// console.log("getYieldOfDefectStatis:", result0);

	// 查询机台在指定时间段内的张数良率
	const getYieldOfDeviceResult = await getYieldOfDevice(jtIds, timeSectionList)
	console.log('getYieldOfDevice result: ', getYieldOfDeviceResult)

	// 查询机台在指定时间段内的调机时间  getAdjustTimeOfDevice
	const getAdjustTimeOfDeviceResult = await getAdjustTimeOfDevice(jtIds, timeSectionList)
	console.log('getAdjustTimeOfDeviceResult result: ', getAdjustTimeOfDeviceResult)

	const result = await getDefectTypeCountOfForeignKey('jt_id', jtIds, {
		startTime: 1095990041000,
		endTime: 3599895400000,
	})
	console.log('getDefectTypeCountOfForeignKey:', result)

	// const getYieldOfWorkshopResult = await getYieldOfWorkshop(workshopIds, timeSectionList)
	// console.log("getYieldOfWorkshop result: ", getYieldOfWorkshopResult);

	// 查询工单在指定时间段内的张数良率
	// const getYieldOfWorkOrderResult = await getYieldOfWorkOrder(workOrderIds, timeSectionList);
	// console.log("getYieldOfWorkOrder result: ", getYieldOfWorkOrderResult);
}
